import moment from 'moment';

(() => {
  AgeAlert.$inject = ["$log", "$filter", "Services", "localStorageService"];

  function AgeAlert($log, $filter, Services, localStorageService) {
    'ngInject';

    return {
      restrict: 'A',

      link(scope, element, attrs) {
        const order = scope.$eval(attrs.ageAlert);

        if (!order) {
          return;
        }

        const currentAge = $filter('age')(order.user.dob);
        const monthsUntilBirthday = 12 - moment().diff(moment(order.user.dob), 'months') % 12;

        const addAlert = function () {
          element.addClass('age-alert');
        };

        const addAlertYellow = function () {
          element.addClass('age-alert-yellow');
        };

        var validacionTriggered = false;
        var pimsParameters = localStorageService.get('pimsParameters');

        if (pimsParameters && pimsParameters.pimsAgeAlertCategories && pimsParameters.pimsAgeAlertCategories.length) {
          pimsParameters.pimsAgeAlertCategories.forEach(category => {
            if (!validacionTriggered) {
              if (category.code === 'GLOBAL' && category.yellow.enabled && !Services.validAgeAlert(category.yellow, currentAge, monthsUntilBirthday)) {
                addAlertYellow();
                validacionTriggered = true;
              } else if (category.code === 'GLOBAL' && category.red.enabled && !Services.validAgeAlert(category.red, currentAge, monthsUntilBirthday)) {
                addAlert();
                validacionTriggered = true;
              } else if (category.code === order.service.code && category.yellow.enabled && !Services.validAgeAlert(category.yellow, currentAge, monthsUntilBirthday)) {
                addAlertYellow();
                validacionTriggered = true;
              } else if (category.yellow_aditional_1 && category.code === order.service.code && category.yellow_aditional_1.enabled && !Services.validAgeAlert(category.yellow_aditional_1, currentAge, monthsUntilBirthday)) {
                addAlertYellow();
                validacionTriggered = true;
              } else if (category.code === order.service.code && category.red.enabled && !Services.validAgeAlert(category.red, currentAge, monthsUntilBirthday)) {
                addAlert();
                validacionTriggered = true;
              }
            }
          });
        }
        /*
        if (currentAge < 18) {
           addAlert();
         } else {
           switch (order.service.code) {
            case 'CP':
              if ((currentAge > 33 || currentAge == 33 && monthsUntilBirthday <= 3) && currentAge < 50) {
                addAlertYellow();
              }
              if (currentAge >= 50) {
                addAlert();
              }
              break;
            case 'UTI':
              if (currentAge >= 65) {
                addAlert();
              }
              break;
            case 'ED':
            case 'EDX':
            case 'EDA':
            case 'PE':
              if (currentAge >= 73 || currentAge < 30) {
                addAlert();
              } else if (currentAge >= 67 && currentAge < 73) {
                addAlertYellow();
              }
              break;
            case 'FLU':
              if (currentAge >= 75) {
                addAlert();
              }
              break;
          }
        }
        */

      }

    };
  }

  angular.module('pims').directive('ageAlert', AgeAlert);
})();